import { useState } from 'react'
import { styles } from '../../../../../../styles/tailwind-config'
import { Label } from '../../../../../../components/ui/label'
import { Switch } from '../../../../../../components/ui/switch'
import { Button } from '../../../../../../components/ui/button'
import { toast } from 'sonner'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useInterventionInput } from '../../../../../../context/InterventionInputContext'
import { AutosizeTextarea } from '../../../../../../components/ui/textarea-autosize'
import Checkbox from '../../../../../../components/ui/checkbox'
import { useTimer } from '../../../../../../context/TimerContext'
import { addSeconds } from 'date-fns'
import { Trans, useLingui } from '@lingui/react/macro'
import { getCustomSettings } from '../../../../../../config/custom-settings'
import { useAuth } from '../../../../../../context/AuthProvider';

const EndIntervention = () => {
  const { auth } = useAuth();
  const navigate = useNavigate()
  const { t } = useLingui()
  const [searchParams, setSearchParams] = useSearchParams()
  const { intervention, solution_visit, solution_extra, start_visit, warranty, setwarranty, follow_up, setfollow_up, maintenance_contract, setmaintenance_contract, notification_dispatch, setnotification_dispatch, used_parts, other_used_parts, used_spareparts, end_visit, setend_visit, follow_up_reason, maintenance_contract_reason, setfollow_up_reason, setmaintenance_contract_reason } = useInterventionInput()
  const { setIsRunning, startTime, elapsedTime } = useTimer()
  const [checked_no_parts, setchecked_no_parts] = useState(false)

  function handleClickCompleteIntervention() {
    // Validate inputs
    const complete = isComplete()
    if (!complete) {
      toast.error(t`Er zijn een of meer fouten in de gegevens. Controleer de velden en probeer het opnieuw.`, { id: 'missingFields', duration: Infinity, position: 'bottom-right' })
      return;
    }

    setIsRunning(false)
    if (!end_visit) {
      const endVisit = addSeconds((start_visit || new Date), elapsedTime)
      setend_visit(endVisit)
    }

    navigate(`/intervention/facturatie?callid=${searchParams.get('callid')}${(intervention && intervention.m_sTYPE) ? `&type=${intervention.m_sTYPE}` : ''}`)
  }

  function isComplete() {
    // Require solution
    const isRequiredSolutation = getCustomSettings(auth.data?.databases[0].dbid).intervention?.description?.require_solution
    if (isRequiredSolutation && !solution_visit) { return false }

    const isRequiredSolutationExtra = getCustomSettings(auth.data?.databases[0].dbid).intervention?.description?.require_solution_extra
    if (isRequiredSolutationExtra && !solution_extra) { return false }

    if (intervention?.m_aBOM.length === 0 || !intervention?.m_aBOM) { return true }

    if ((!used_parts || used_parts.length === 0) && (!other_used_parts || other_used_parts.length === 0) && (!used_spareparts || used_spareparts.length === 0)) {
      return checked_no_parts
    }
    return true
  }

  return (
    <div className='flex flex-col gap-4'>
      <h3 className={`${styles.h3}`}><Trans>Einde van de interventie</Trans></h3>

      <div className='flex items-center justify-between gap-4'>
        <Label><Trans>Garantie</Trans></Label>
        <Switch checked={warranty || false} onCheckedChange={(v) => { setwarranty(v) }} />
      </div>
      <div className='flex items-center justify-between gap-4'>
        <Label><Trans>Is er een vervolgafspraak nodig?</Trans></Label>
        <Switch checked={follow_up || false} onCheckedChange={(v) => { setfollow_up(v) }} />
      </div>
      {follow_up &&
        <div className='flex flex-col gap-1'>
          <Label><Trans>Reden</Trans></Label>
          <AutosizeTextarea value={follow_up_reason || ''} onChange={(e) => { setfollow_up_reason(e.target.value) }} />
        </div>
      }
      <div className='flex items-center justify-between gap-4'>
        <Label><Trans>Is de klant geïnteresseerd in een onderhoudscontract?</Trans></Label>
        <Switch checked={maintenance_contract || false} onCheckedChange={(v) => { setmaintenance_contract(v) }} />
      </div>
      {maintenance_contract &&
        <div className='flex flex-col gap-1'>
          <Label><Trans>Opmerkingen</Trans></Label>
          <AutosizeTextarea value={maintenance_contract_reason || ''} onChange={(e) => { setmaintenance_contract_reason(e.target.value) }} />
        </div>
      }
      <div>
        <Label><Trans>Melding voor interne dispatching</Trans></Label>
        <AutosizeTextarea value={notification_dispatch || ''} onChange={(e) => { setnotification_dispatch(e.target.value) }} />
      </div>


      {(intervention && intervention?.m_aBOM.length > 0) && <>
        {((!used_parts || used_parts.length === 0) && (!other_used_parts || other_used_parts.length === 0) && (!used_spareparts || used_spareparts.length === 0)) &&
          <div className='flex items-center gap-1 p-2 text-red-600 rounded-md bg-red-50'>
            <Checkbox checked={checked_no_parts} onCheckedChange={(v) => { setchecked_no_parts(v) }} id='no-parts' className='border-red-600' backgroundClassName='bg-red-600' />
            <Label htmlFor='no-parts'><Trans>Ik weet dat ik geen gebruikte wisselstukken heb</Trans></Label>
          </div>
        }
      </>}

      <Button disabled={!isComplete()} onClick={() => { handleClickCompleteIntervention() }} className='w-full'><Trans>Doorgaan naar facturatie</Trans></Button>

    </div>
  )
}

export default EndIntervention